import axios from "axios";

export function getLecturerList(centerId) {
  const config = {
    params: {
      centerId: centerId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/lecturerlist", config);
}

export function getLecturerListByClassId(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/lecturerlistbyclassid", config);
}

export function sendEmailLecturerByClassId(classId) {
  const config = {
    params: {
      classId: classId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Lecturer/sendemaillecturer", config);
}
